import React, { useEffect, useRef } from 'react';
import Hero from './Hero';
import Services from './Services';
import Slideshow from './Slideshow';
import About from './About';
import Testimonials from './Testimonials';
import Footer from './Footer';

/**
 * HomePage Component
 * The main landing page with all original sections.
 */
function HomePage() {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    sectionRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Hero />
      <div ref={(el) => (sectionRefs.current[0] = el)} className="reveal-wrap">
        <Services />
      </div>
      <div ref={(el) => (sectionRefs.current[1] = el)} className="reveal-wrap">
        <Slideshow />
      </div>
      <div ref={(el) => (sectionRefs.current[2] = el)} className="reveal-wrap">
        <About />
      </div>
      <div ref={(el) => (sectionRefs.current[3] = el)} className="reveal-wrap">
        <Testimonials />
      </div>
      <div ref={(el) => (sectionRefs.current[4] = el)} className="reveal-wrap">
        <Footer />
      </div>
    </>
  );
}

export default HomePage;
